import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vModelText as _vModelText, withKeys as _withKeys, normalizeClass as _normalizeClass, vModelDynamic as _vModelDynamic, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "login-box" }
const _hoisted_2 = { class: "logo" }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "title t-c" }, "登 录", -1)
const _hoisted_5 = { class: "prompt t-c" }
const _hoisted_6 = { class: "form-box" }
const _hoisted_7 = { class: "input-base" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "账号", -1)
const _hoisted_9 = { class: "prompt" }
const _hoisted_10 = { class: "userinfo-box" }
const _hoisted_11 = ["src"]
const _hoisted_12 = { class: "username" }
const _hoisted_13 = { class: "input-base" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "密码", -1)
const _hoisted_15 = ["type"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", { src: "static/icon/look.svg" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "prompt" }
const _hoisted_19 = { class: "userinfo-box" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "username" }
const _hoisted_22 = { class: "input-base" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "验证码", -1)
const _hoisted_24 = ["src"]
const _hoisted_25 = { class: "prompt" }
const _hoisted_26 = { class: "input-base" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "用户名", -1)
const _hoisted_28 = { class: "prompt" }
const _hoisted_29 = { class: "userinfo-box" }
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "username" }
const _hoisted_32 = { class: "input-base" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "电子邮箱", -1)
const _hoisted_34 = { class: "prompt" }
const _hoisted_35 = { class: "userinfo-box" }
const _hoisted_36 = ["src"]
const _hoisted_37 = { class: "username" }
const _hoisted_38 = { class: "input-base" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "验证码", -1)
const _hoisted_40 = {
  key: 1,
  class: "refresh-box refresh-invalid"
}
const _hoisted_41 = { class: "prompt" }
const _hoisted_42 = { class: "userinfo-box" }
const _hoisted_43 = ["src"]
const _hoisted_44 = { class: "username" }
const _hoisted_45 = { class: "input-base" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "新密码", -1)
const _hoisted_47 = ["type"]
const _hoisted_48 = /*#__PURE__*/_createElementVNode("img", { src: "static/icon/look.svg" }, null, -1)
const _hoisted_49 = [
  _hoisted_48
]
const _hoisted_50 = { class: "prompt" }
const _hoisted_51 = { class: "userinfo-box" }
const _hoisted_52 = ["src"]
const _hoisted_53 = { class: "username" }
const _hoisted_54 = { class: "input-base" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "确认密码", -1)
const _hoisted_56 = ["type"]
const _hoisted_57 = /*#__PURE__*/_createElementVNode("img", { src: "static/icon/look.svg" }, null, -1)
const _hoisted_58 = [
  _hoisted_57
]
const _hoisted_59 = { class: "prompt" }
const _hoisted_60 = {
  key: 0,
  class: "operating-box"
}
const _hoisted_61 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "返回登录", -1)
const _hoisted_62 = {
  key: 1,
  class: "operating-box"
}
const _hoisted_63 = { class: "auto-login" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("p", { class: "name" }, "7天内自动登录", -1)
const _hoisted_65 = /*#__PURE__*/_createElementVNode("p", { class: "title" }, "忘记密码？", -1)
const _hoisted_66 = [
  _hoisted_65
]
const _hoisted_67 = { class: "setting-box" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("div", { class: "copyright-box" }, "This program is supported by Shenghao Technology Co., Ltd.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_elem_icon = _resolveComponent("elem-icon")!
  const _component_comp_menu = _resolveComponent("comp-menu")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["login-page page-theme-dark", { 'login-page-display': _ctx.display }])
  }, [
    (_ctx.input_step !== 'username')
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "back-box",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onBackStep && _ctx.onBackStep(...args)))
        }, [
          _createVNode(_component_elem_icon, { name: "back" })
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _withDirectives(_createElementVNode("img", {
          class: "logo-icon",
          src: _ctx.info.icon
        }, null, 8, _hoisted_3), [
          [_vShow, _ctx.info.icon]
        ])
      ]),
      _hoisted_4,
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.prompt || _ctx.info.name + " - 管理后台"), 1),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          class: _normalizeClass(["item-box", { display: _ctx.input_step === 'username' }])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["input-box", { focus: _ctx.input_focus.username || _ctx.username }])
            }, [
              _hoisted_8,
              _withDirectives(_createElementVNode("input", {
                ref: "username_input",
                autocomplete: "new-password",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.username) = $event)),
                name: "username",
                class: "input",
                title: "用户名",
                required: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeFocusInput('username', true))),
                onFocus: _cache[3] || (_cache[3] = ($event: any) => (_ctx.onChangeFocusInput('username', true))),
                onBlur: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onChangeFocusInput('username', false))),
                onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onChangeInput('username_error'))),
                onKeyup: _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitInput && _ctx.onSubmitInput(...args)), ["enter"]))
              }, null, 544), [
                [_vModelText, _ctx.username]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["line-box", { 'show-loading': _ctx.loading }])
              }, null, 2)
            ], 2),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.username_error), 1)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-box userinfo-item", { display: _ctx.input_step === 'password' }])
        }, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("img", {
              class: "avatar",
              src: _ctx.userinfo.avatar
            }, null, 8, _hoisted_11),
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.userinfo.username), 1),
            _createElementVNode("div", {
              class: "change-btn",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.input_step = 'username'))
            }, "更改")
          ]),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("div", {
              class: _normalizeClass(["input-box", { focus: _ctx.input_focus.password || _ctx.password }])
            }, [
              _hoisted_14,
              _withDirectives(_createElementVNode("input", {
                ref: "password_input",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.password) = $event)),
                name: "password",
                type: _ctx.isPasswordType ? 'password' : 'text',
                class: "input",
                title: "密码",
                required: "",
                onFocus: _cache[9] || (_cache[9] = ($event: any) => (_ctx.onChangeFocusInput('password', true))),
                onBlur: _cache[10] || (_cache[10] = ($event: any) => (_ctx.onChangeFocusInput('password', false))),
                onInput: _cache[11] || (_cache[11] = ($event: any) => (_ctx.onChangeInput('password_error'))),
                onKeyup: _cache[12] || (_cache[12] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitInput && _ctx.onSubmitInput(...args)), ["enter"]))
              }, null, 40, _hoisted_15), [
                [_vModelDynamic, _ctx.password]
              ]),
              _createElementVNode("div", {
                class: "icon",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onChangePasswordType && _ctx.onChangePasswordType(...args)))
              }, _hoisted_17),
              _createElementVNode("div", {
                class: _normalizeClass(["line-box", { 'show-loading': _ctx.loading }])
              }, null, 2)
            ], 2),
            _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.password_error), 1)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-box userinfo-item", { display: _ctx.input_step === 'code' }])
        }, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("img", {
              class: "avatar",
              src: _ctx.userinfo.avatar
            }, null, 8, _hoisted_20),
            _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.userinfo.username), 1),
            _createElementVNode("div", {
              class: "change-btn",
              onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.input_step = 'username'))
            }, "更改")
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", {
              class: _normalizeClass(["input-box", { focus: _ctx.input_focus.code || _ctx.code }])
            }, [
              _hoisted_23,
              _withDirectives(_createElementVNode("input", {
                ref: "code_input",
                autocomplete: "new-password",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.code) = $event)),
                name: "code",
                type: "text",
                class: "input",
                title: "验证码",
                required: "",
                onFocus: _cache[16] || (_cache[16] = ($event: any) => (_ctx.onChangeFocusInput('code', true))),
                onBlur: _cache[17] || (_cache[17] = ($event: any) => (_ctx.onChangeFocusInput('code', false))),
                onKeyup: _cache[18] || (_cache[18] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitInput && _ctx.onSubmitInput(...args)), ["enter"])),
                onInput: _cache[19] || (_cache[19] = ($event: any) => (_ctx.onChangeInput('code_error')))
              }, null, 544), [
                [_vModelText, _ctx.code]
              ]),
              _createElementVNode("div", {
                class: "code-box",
                onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => (_ctx.getValidateCode && _ctx.getValidateCode(...args)))
              }, [
                (_ctx.codeInfo)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "code",
                      src: _ctx.codeInfo.image,
                      width: "70",
                      height: "30"
                    }, null, 8, _hoisted_24))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["line-box", { 'show-loading': _ctx.loading }])
              }, null, 2)
            ], 2),
            _createElementVNode("p", _hoisted_25, _toDisplayString(_ctx.code_error), 1)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-box", { display: _ctx.input_step === 'forgot_username' }])
        }, [
          _createElementVNode("div", _hoisted_26, [
            _createElementVNode("div", {
              class: _normalizeClass(["input-box", { focus: _ctx.input_focus.forgot_username || _ctx.forgot_username }])
            }, [
              _hoisted_27,
              _withDirectives(_createElementVNode("input", {
                ref: "forgot_username_input",
                autocomplete: "new-password",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.forgot_username) = $event)),
                name: "forgot_username",
                type: "text",
                class: "input",
                title: "用户名",
                required: "",
                onFocus: _cache[22] || (_cache[22] = ($event: any) => (_ctx.onChangeFocusInput('forgot_username', true))),
                onBlur: _cache[23] || (_cache[23] = ($event: any) => (_ctx.onChangeFocusInput('forgot_username', false))),
                onKeyup: _cache[24] || (_cache[24] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitForgotUsername && _ctx.onSubmitForgotUsername(...args)), ["enter"])),
                onInput: _cache[25] || (_cache[25] = ($event: any) => (_ctx.onChangeInput('forgot_username_error')))
              }, null, 544), [
                [_vModelText, _ctx.forgot_username]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["line-box", { 'show-loading': _ctx.loading }])
              }, null, 2)
            ], 2),
            _createElementVNode("p", _hoisted_28, _toDisplayString(_ctx.forgot_username_error), 1)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-box userinfo-item", { display: _ctx.input_step === 'forgot_email' }])
        }, [
          _createElementVNode("div", _hoisted_29, [
            _createElementVNode("img", {
              class: "avatar",
              src: _ctx.userinfo.avatar
            }, null, 8, _hoisted_30),
            _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.userinfo.username), 1),
            _createElementVNode("div", {
              class: "change-btn",
              onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.input_step = 'forgot_username'))
            }, "更改")
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createElementVNode("div", {
              class: _normalizeClass(["input-box", { focus: _ctx.input_focus.forgot_email || _ctx.forgot_email }])
            }, [
              _hoisted_33,
              _withDirectives(_createElementVNode("input", {
                ref: "forgot_email_input",
                autocomplete: "new-password",
                "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.forgot_email) = $event)),
                name: "forgot_email",
                type: "text",
                class: "input",
                title: "用户名",
                required: "",
                onFocus: _cache[28] || (_cache[28] = ($event: any) => (_ctx.onChangeFocusInput('forgot_email', true))),
                onBlur: _cache[29] || (_cache[29] = ($event: any) => (_ctx.onChangeFocusInput('forgot_email', false))),
                onKeyup: _cache[30] || (_cache[30] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitForgotEmail && _ctx.onSubmitForgotEmail(...args)), ["enter"])),
                onInput: _cache[31] || (_cache[31] = ($event: any) => (_ctx.onChangeInput('forgot_email_error')))
              }, null, 544), [
                [_vModelText, _ctx.forgot_email]
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["line-box", { 'show-loading': _ctx.loading }])
              }, null, 2)
            ], 2),
            _createElementVNode("p", _hoisted_34, _toDisplayString(_ctx.forgot_email_error), 1)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-box userinfo-item", { display: _ctx.input_step === 'forgot_code' }])
        }, [
          _createElementVNode("div", _hoisted_35, [
            _createElementVNode("img", {
              class: "avatar",
              src: _ctx.userinfo.avatar
            }, null, 8, _hoisted_36),
            _createElementVNode("p", _hoisted_37, _toDisplayString(_ctx.userinfo.username), 1),
            _createElementVNode("div", {
              class: "change-btn",
              onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.input_step = 'forgot_username'))
            }, "更改")
          ]),
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("div", {
              class: _normalizeClass(["input-box", { focus: _ctx.input_focus.forgot_code || _ctx.forgot_code }])
            }, [
              _hoisted_39,
              _withDirectives(_createElementVNode("input", {
                ref: "forgot_code_input",
                autocomplete: "new-password",
                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.forgot_code) = $event)),
                name: "forgot_code",
                type: "text",
                class: "input",
                title: "用户名",
                required: "",
                onFocus: _cache[34] || (_cache[34] = ($event: any) => (_ctx.onChangeFocusInput('forgot_code', true))),
                onBlur: _cache[35] || (_cache[35] = ($event: any) => (_ctx.onChangeFocusInput('forgot_code', false))),
                onKeyup: _cache[36] || (_cache[36] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitForgotCode && _ctx.onSubmitForgotCode(...args)), ["enter"])),
                onInput: _cache[37] || (_cache[37] = ($event: any) => (_ctx.onChangeInput('forgot_code_error')))
              }, null, 544), [
                [_vModelText, _ctx.forgot_code]
              ]),
              (_ctx.forgot_code_time === '00')
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "refresh-box",
                    onClick: _cache[38] || (_cache[38] = 
//@ts-ignore
(...args) => (_ctx.onSendForgotCode && _ctx.onSendForgotCode(...args)))
                  }, "重新发送"))
                : (_openBlock(), _createElementBlock("div", _hoisted_40, "00:" + _toDisplayString(_ctx.forgot_code_time), 1)),
              _createElementVNode("div", {
                class: _normalizeClass(["line-box", { 'show-loading': _ctx.loading }])
              }, null, 2)
            ], 2),
            _createElementVNode("p", _hoisted_41, _toDisplayString(_ctx.forgot_code_error), 1)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-box userinfo-item", { display: _ctx.input_step === 'forgot_password' }])
        }, [
          _createElementVNode("div", _hoisted_42, [
            _createElementVNode("img", {
              class: "avatar",
              src: _ctx.userinfo.avatar
            }, null, 8, _hoisted_43),
            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.userinfo.username), 1),
            _createElementVNode("div", {
              class: "change-btn",
              onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.input_step = 'forgot_username'))
            }, "更改")
          ]),
          _createElementVNode("div", _hoisted_45, [
            _createElementVNode("div", {
              class: _normalizeClass(["input-box", { focus: _ctx.input_focus.forgot_password || _ctx.forgot_password }])
            }, [
              _hoisted_46,
              _withDirectives(_createElementVNode("input", {
                ref: "forgot_password_input",
                autocomplete: "new-password",
                "onUpdate:modelValue": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.forgot_password) = $event)),
                name: "forgot_password",
                type: _ctx.isPasswordType ? 'password' : 'text',
                class: "input",
                title: "新密码",
                required: "",
                onFocus: _cache[41] || (_cache[41] = ($event: any) => (_ctx.onChangeFocusInput('forgot_password', true))),
                onBlur: _cache[42] || (_cache[42] = ($event: any) => (_ctx.onChangeFocusInput('forgot_password', false))),
                onInput: _cache[43] || (_cache[43] = ($event: any) => (_ctx.onChangeInput('forgot_password_error'))),
                onKeyup: _cache[44] || (_cache[44] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitInput && _ctx.onSubmitInput(...args)), ["enter"]))
              }, null, 40, _hoisted_47), [
                [_vModelDynamic, _ctx.forgot_password]
              ]),
              _createElementVNode("div", {
                class: "icon",
                onClick: _cache[45] || (_cache[45] = 
//@ts-ignore
(...args) => (_ctx.onChangePasswordType && _ctx.onChangePasswordType(...args)))
              }, _hoisted_49),
              _createElementVNode("div", {
                class: _normalizeClass(["line-box", { 'show-loading': _ctx.loading }])
              }, null, 2)
            ], 2),
            _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.forgot_password_error), 1)
          ])
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["item-box userinfo-item", { display: _ctx.input_step === 'forgot_confirm_password' }])
        }, [
          _createElementVNode("div", _hoisted_51, [
            _createElementVNode("img", {
              class: "avatar",
              src: _ctx.userinfo.avatar
            }, null, 8, _hoisted_52),
            _createElementVNode("p", _hoisted_53, _toDisplayString(_ctx.userinfo.username), 1),
            _createElementVNode("div", {
              class: "change-btn",
              onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.input_step = 'forgot_username'))
            }, "更改")
          ]),
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", {
              class: _normalizeClass(["input-box", { focus: _ctx.input_focus.forgot_confirm_password || _ctx.forgot_confirm_password }])
            }, [
              _hoisted_55,
              _withDirectives(_createElementVNode("input", {
                ref: "forgot_confirm_password_input",
                autocomplete: "new-password",
                "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => ((_ctx.forgot_confirm_password) = $event)),
                name: "forgot_confirm_password",
                type: _ctx.isPasswordType ? 'password' : 'text',
                class: "input",
                title: "新密码",
                required: "",
                onFocus: _cache[48] || (_cache[48] = ($event: any) => (_ctx.onChangeFocusInput('forgot_confirm_password', true))),
                onBlur: _cache[49] || (_cache[49] = ($event: any) => (_ctx.onChangeFocusInput('forgot_confirm_password', false))),
                onInput: _cache[50] || (_cache[50] = ($event: any) => (_ctx.onChangeInput('forgot_confirm_password_error'))),
                onKeyup: _cache[51] || (_cache[51] = _withKeys(
//@ts-ignore
(...args) => (_ctx.onSubmitInput && _ctx.onSubmitInput(...args)), ["enter"]))
              }, null, 40, _hoisted_56), [
                [_vModelDynamic, _ctx.forgot_confirm_password]
              ]),
              _createElementVNode("div", {
                class: "icon",
                onClick: _cache[52] || (_cache[52] = 
//@ts-ignore
(...args) => (_ctx.onChangePasswordType && _ctx.onChangePasswordType(...args)))
              }, _hoisted_58),
              _createElementVNode("div", {
                class: _normalizeClass(["line-box", { 'show-loading': _ctx.loading }])
              }, null, 2)
            ], 2),
            _createElementVNode("p", _hoisted_59, _toDisplayString(_ctx.forgot_confirm_password_error), 1)
          ])
        ], 2)
      ]),
      _createElementVNode("button", {
        class: "submit t-c t-b-b",
        onClick: _cache[53] || (_cache[53] = 
//@ts-ignore
(...args) => (_ctx.onNextStep && _ctx.onNextStep(...args)))
      }, _toDisplayString(_ctx.getStepTitle()), 1),
      (_ctx.isForgot())
        ? (_openBlock(), _createElementBlock("div", _hoisted_60, [
            _createElementVNode("div", {
              class: "btn-box",
              onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.input_step = 'username'))
            }, [
              _createVNode(_component_elem_icon, {
                class: "icon",
                name: "back"
              }),
              _hoisted_61
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_62, [
            _createElementVNode("div", _hoisted_63, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.auto_login) = $event)),
                name: "auto",
                id: "AutoLogin",
                type: "checkbox"
              }, null, 512), [
                [_vModelCheckbox, _ctx.auto_login]
              ]),
              _hoisted_64
            ]),
            _createElementVNode("div", {
              class: "btn-box",
              onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.input_step = 'forgot_username'))
            }, _hoisted_66)
          ]))
    ]),
    _createElementVNode("div", _hoisted_67, [
      _createVNode(_component_elem_icon, { name: "menu" }),
      _createVNode(_component_comp_menu, {
        value: _ctx.setting_menu,
        absolute: true,
        onSelect: _ctx.onSelectSettingMenu
      }, null, 8, ["value", "onSelect"])
    ]),
    _hoisted_68
  ], 2)), [
    [_vShow, _ctx.show]
  ])
}